<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="商品名称">
                <a-input v-model="queryParam.goodsName" placeholder="请输入商品名称" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="SKU名称">
                <a-input v-model="queryParam.skuName" placeholder="请输入SKU名称" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="预警状态">
                <a-select v-model="queryParam.alarmFlag" placeholder="请选择" allow-clear>
                  <a-select-option :value="0">正常</a-select-option>
                  <a-select-option :value="1">预警</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery">
                  <a-icon type="search" />查询
                </a-button>
                <a-button style="margin-left: 8px" @click="resetQuery">
                  <a-icon type="redo" />重置
                </a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.initForm.handleAdd()" v-hasPermi="['retail:inventory:init']">
          <a-icon type="plus" />采购入库
        </a-button>
        <a-button type="danger" @click="$refs.returnForm.handleAdd()" v-hasPermi="['retail:inventory:return']">
          <a-icon type="rollback" />采购退货
        </a-button>
        <a-button type="default" @click="$refs.returnRecordModal.handleShow()" v-hasPermi="['retail:inventory:thquery']">
          <a-icon type="unordered-list" />退货记录
        </a-button>
      </div>

      <!-- 采购入库表单 -->
      <init-form ref="initForm" @ok="getList" />

      <!-- 采购退货表单 -->
      <return-form ref="returnForm" @ok="getList" />

      <!-- 退货记录弹窗 -->
      <return-record-modal ref="returnRecordModal" />

      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="pagination"
        :bordered="tableBordered"
        @change="handleTableChange"
      >
        <span slot="goodsName" slot-scope="text">
          {{ text || '-' }}
        </span>
        <span slot="skuName" slot-scope="text">
          {{ text || '-' }}
        </span>
        <span slot="availableStock" slot-scope="text">
          <a-tag :color="text > 0 ? 'green' : 'red'">{{ text }}</a-tag>
        </span>
        <span slot="purchasePrice" slot-scope="text">
          ¥{{ text ? parseFloat(text).toFixed(2) : '0.00' }}
        </span>
        <span slot="merchantPrice" slot-scope="text">
          ¥{{ text ? parseFloat(text).toFixed(2) : '0.00' }}
        </span>
        <span slot="alarmFlag" slot-scope="text">
          <a-tag :color="text === 1 ? 'red' : 'green'">{{ text === 1 ? '预警' : '正常' }}</a-tag>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="handleDetail(record)" v-hasPermi="['retail:inventory:query']">
            <a-icon type="eye" />详情
          </a>
        </span>
      </a-table>
    </a-card>

    <!-- 库存详情弹窗 -->
    <a-modal
      title="库存详情"
      :visible="detailVisible"
      :footer="null"
      @cancel="detailVisible = false"
      width="800px"
    >
      <a-descriptions bordered :column="2" v-if="currentDetail">
        <a-descriptions-item label="商品名称">{{ currentDetail.goodsName || '-' }}</a-descriptions-item>
        <a-descriptions-item label="SKU名称">{{ currentDetail.skuName || '-' }}</a-descriptions-item>
        <a-descriptions-item label="可用库存">
          <a-tag color="green">{{ currentDetail.availableStock || 0 }}</a-tag>
        </a-descriptions-item>
<!--        <a-descriptions-item label="锁定库存">-->
<!--          <a-tag color="orange">{{ currentDetail.lockedStock || 0 }}</a-tag>-->
<!--        </a-descriptions-item>-->
        <a-descriptions-item label="预警库存">{{ currentDetail.alarmStock || 0 }}</a-descriptions-item>
        <a-descriptions-item label="采购价(元)" v-if="!isWarehouseManager">{{ currentDetail.purchasePrice || '0.00' }}</a-descriptions-item>
        <a-descriptions-item label="商家拿货价(元)" v-if="!isWarehouseManager">{{ currentDetail.merchantPrice || '0.00' }}</a-descriptions-item>
        <a-descriptions-item label="创建时间">{{ parseTime(currentDetail.createTime) }}</a-descriptions-item>
      </a-descriptions>
    </a-modal>
  </page-header-wrapper>
</template>

<script>
import { getInventoryList, getInventoryDetail } from '@/api/retail/inventory'
import InitForm from './modules/InitForm'
import ReturnForm from './modules/ReturnForm'
import ReturnRecordModal from './modules/ReturnRecordModal'
import { tableMixin } from '@/store/table-mixin'
import moment from 'moment'

// 仓库管理角色标识：该角色不可查看任何金额
const WAREHOUSE_ROLE_KEYS = ['仓库管理']

export default {
  name: 'Inventory',
  components: {
    InitForm,
    ReturnForm,
    ReturnRecordModal
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      loading: false,
      detailVisible: false,
      currentDetail: null,
      queryParam: {
        orgId: undefined,
        orgType: undefined,
        goodsName: undefined,
        skuName: undefined,
        alarmFlag: undefined
      },
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showTotal: total => `共 ${total} 条`,
        pageSizeOptions: ['10', '20', '30', '50', '100']
      }
    }
  },
  computed: {
    // 当前登录用户是否为仓库管理角色
    isWarehouseManager() {
      const roles = this.$store.getters.roles || []
      const roleList = Array.isArray(roles) ? roles : Array.from(roles)
      return WAREHOUSE_ROLE_KEYS.some(key => roleList.includes(key))
    },
    // 列表列：仓库管理角色隐藏所有金额列
    columns() {
      const columns = [
        {
          title: '商品名称',
          dataIndex: 'goodsName',
          width: 200,
          ellipsis: true,
          scopedSlots: { customRender: 'goodsName' },
          align: 'center'
        },
        {
          title: 'SKU名称',
          dataIndex: 'skuName',
          width: 200,
          ellipsis: true,
          scopedSlots: { customRender: 'skuName' },
          align: 'center'
        },
        {
          title: '可用库存',
          dataIndex: 'availableStock',
          width: 100,
          scopedSlots: { customRender: 'availableStock' },
          align: 'center'
        }
      ]
      // 仓库管理角色不可查看任何金额
      if (!this.isWarehouseManager) {
        columns.push(
          {
            title: '采购价(元)',
            dataIndex: 'purchasePrice',
            width: 120,
            align: 'center'
          },
          {
            title: '商家拿货价(元)',
            dataIndex: 'merchantPrice',
            width: 130,
            align: 'center'
          }
        )
      }
      columns.push(
        // {
        //   title: '锁定库存',
        //   dataIndex: 'lockedStock',
        //   width: 100,
        //   scopedSlots: { customRender: 'lockedStock' },
        //   align: 'center'
        // },
        {
          title: '预警库存',
          dataIndex: 'alarmStock',
          width: 100,
          align: 'center'
        },
        {
          title: '预警状态',
          dataIndex: 'alarmFlag',
          width: 100,
          scopedSlots: { customRender: 'alarmFlag' },
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          width: 180,
          scopedSlots: { customRender: 'createTime' },
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 100,
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      )
      return columns
    }
  },
  created() {
    this.queryParam.orgId = this.$store.getters.orgId
    this.queryParam.orgType = this.$store.getters.orgType
    this.getList()
  },
  methods: {
    moment,
    parseTime(time) {
      return time ? moment(time).format('YYYY-MM-DD HH:mm:ss') : '-'
    },
    getList() {
      this.loading = true
      const params = {
        ...this.queryParam,
        current: this.pagination.current,
        size: this.pagination.pageSize
      }
      getInventoryList(params).then(response => {
        // 兼容分页和非分页响应格式
        if (response.data && response.data.records) {
          // 分页响应格式
          this.list = response.data.records || []
          this.pagination.total = response.data.total || 0
        } else if (Array.isArray(response)) {
          // 直接数组响应格式
          this.list = response
          this.pagination.total = response.length
        } else if (response.data && Array.isArray(response.data)) {
          // 响应在data中是数组
          this.list = response.data
          this.pagination.total = response.data.length
        } else {
          this.list = []
          this.pagination.total = 0
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    handleQuery() {
      this.pagination.current = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam = {
        orgId: this.$store.getters.orgId,
        orgType: this.$store.getters.orgType,
        goodsName: undefined,
        skuName: undefined,
        alarmFlag: undefined
      }
      this.pagination.current = 1
      this.getList()
    },
    handleTableChange(pagination) {
      this.pagination = pagination
      this.getList()
    },
    handleDetail(record) {
      getInventoryDetail({
        id: record.id
      }).then(response => {
        // 兼容不同的响应格式
        if (response && response.data) {
          this.currentDetail = response.data
        } else {
          this.currentDetail = response
        }
        this.detailVisible = true
      }).catch(error => {
        console.error('获取库存详情失败:', error)
        this.$message.error('获取库存详情失败')
      })
    }
  }
}
</script>
